import { render, staticRenderFns } from "./UnlockPrompt.vue?vue&type=template&id=cbe97cd0&scoped=true&"
import script from "./UnlockPrompt.vue?vue&type=script&lang=js&"
export * from "./UnlockPrompt.vue?vue&type=script&lang=js&"
import style0 from "./UnlockPrompt.vue?vue&type=style&index=0&id=cbe97cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe97cd0",
  null
  
)

export default component.exports